export const timeout = 250;
